export default __webpack_public_path__ + "static/media/faq_pink.9e4bd6ea.svg";